import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.features.unarchive-credit-card-item.presenters.UnarchiveCreditCardItemPresenter`

export default defineMessages({
  successTitle: {
    id: `${scope}.successTitle`,
    defaultMessage: 'Success',
  },
  successMessage: {
    id: `${scope}.successMessage`,
    defaultMessage: 'Item {description} has been unarchived.',
  },
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  genericErrorMessage: {
    id: `${scope}.genericErrorMessage`,
    defaultMessage: 'Unable to unarchive the credit card item.',
  },
})
